import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import { observable, action, runInAction, makeAutoObservable } from 'mobx';
import Subjects from '../../models/subjects';
import { TaskService } from '../../services/task-service';
import { UploadChangeParam } from 'antd/lib/upload';
import { message } from 'antd';

export default class ImageUploaderStore {

    @observable
    inactive: boolean;

    @observable
    taskId: number | null;

    @observable
    url: string;

    @observable
    files: UploadFile[] | [];

    @observable
    loading: boolean;

    isMainPhoto: boolean;

    subject: Subjects;

    mathTaskService: TaskService;

    constructor(subject: Subjects, isMainPhoto: boolean) {
        this.inactive = true;
        this.subject = subject;
        this.taskId = null;
        this.url = "";
        this.mathTaskService = new TaskService();
        this.isMainPhoto = isMainPhoto;
        this.files = [];
        this.loading = false;
        makeAutoObservable(this);
    }

    @action
    reset() {
        this.inactive = true;
        this.taskId = null;
        this.url = "";
        this.files = [];
    }

    @action
    changeActivated(active: boolean) {
        this.inactive = !active;
    }

    @action
    setTaskId(taskId: number) {
        this.taskId = taskId;
        this.url = this.getUrl(taskId);
    }

    @action
    setFile(newFile: UploadFile) {
        if (!this.inactive) {
            this.files = [...this.files, newFile];
        }
    }

    @action
    setFiles(newFiles: UploadFile[]) {
        if (!this.inactive) {
            this.files = newFiles;
        }
    }

    @action
    handleOnChange(info: UploadChangeParam<UploadFile<any>>) {
        runInAction(() => {
            const { status } = info.file;

            if (status === 'done') {
                message.success(`${info.file.name} успешно загружен`);
            } else if (status === 'error') {
                message.error(`Во время загрузки файла ${info.file.name} произошла ошибка`);
            }
            this.files = info.fileList;
        });
    }

    getUrl(taskId: number): string {

        if (this.subject === Subjects.MATH) {
            return this.mathTaskService.getPhotoUploadUrl(taskId, this.isMainPhoto);
        }

        return "";
    }

    @action
    handleManualUpload(newFile: UploadFile) {

        console.log("paste3 " + this.inactive + "  " + this.taskId);

        if (!this.inactive && this.taskId) {

            this.loading = true;

            this.mathTaskService
                .loadPhoto(newFile.originFileObj as RcFile, this.isMainPhoto, this.taskId)
                .then((res) => {
                    if (res.ok) {
                        runInAction(() => {
                            message.success(`${newFile.name} успешно загружен`);
                            this.files = [...this.files, newFile];
                            this.loading = false;
                        });
                    } else {
                        runInAction(() => {
                            message.error(`Во время загрузки файла ${newFile.name} произошла ошибка`);
                            this.loading = false;
                        });
                    }
                });

        }
    }
}